jQuery($ => {
    class MapLinks {
        constructor(element) {
            this._        = element;
            this._element = $(element);
            this._svg = this._element.find('.a-map-links__inner svg');
            this._groupEL = this._svg.find('g');
            this._linkItem = this._element.find('.a-map-links__link-item');

            this.init();
        } 

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
        init() {
            this.setupHandlers();
            this._element.trigger( 'init', this );
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            this._groupEL.each((index, element) => {
                $(element).on('mousemove', (event) => {
                    var id = $(event.currentTarget).attr('id');

                    // Get the parent container
                    var parentContainer = $(event.currentTarget).closest('.a-map-links__inner'); // Change this selector to match your parent container

                    // Get the cursor position relative to the parent container
                    var containerOffset = parentContainer.offset();
                    var containerWidth = parentContainer.width();
                    var containerHeight = parentContainer.height();

                    var relativeX = event.pageX - containerOffset.left;
                    var relativeY = event.pageY - containerOffset.top;

                    // Convert position to percentage
                    var leftPercentage = ((relativeX / containerWidth) * 100) + 1;  // 1% to the right
                    var topPercentage = ((relativeY / containerHeight) * 100) + 1;  // 1% to the bottom

                    // Find the corresponding <a> tag with the same class as the id
                    var correspondingLink = this._linkItem.filter((index, link) => {
                        return $(link).hasClass(id); // Filter to get the matching link
                    });

                    if (correspondingLink.length > 0) {
                        // Set position to absolute and adjust by percentage
                        $(correspondingLink).css({
                            'position': 'absolute',
                            'left': leftPercentage + '%',
                            'top': topPercentage + '%',
                            'opacity': '1',
                        });
                    }
                });

                $(element).on('mouseout', (event) => {
                    var id = $(event.currentTarget).attr('id');

                    // Find the corresponding <a> tag with the same class as the id
                    var correspondingLink = this._linkItem.filter((index, link) => {
                        return $(link).hasClass(id); // Filter to get the matching link
                    });

                    if (correspondingLink.length > 0) {
                        // Change opacity of the found link
                        $(correspondingLink).css('opacity', '0');
                    }
                });

                $(element).on('click', (event) => {
                    var id = $(event.currentTarget).attr('id');

                    // Find the corresponding <a> tag with the same class as the id
                    var correspondingLink = this._linkItem.filter((index, link) => {
                        return $(link).hasClass(id); // Filter to get the matching link
                    });

                    if (correspondingLink.length > 0) {
                        var url = correspondingLink.attr('href'); // Get the URL from the <a> tag
                        window.open(url, '_self');
                    } else {
                        console.log('No corresponding link found.');
                    }
                });
            });


        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.map_links = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].map_links = new MapLinks(_[i], opt);
            else
                ret = _[i].map_links[opt].apply(_[i].map_links, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.a-map-links').map_links();
});